import SearchMultiSelectOld from './SearchMultiSelectOld'

export default SearchMultiSelectOld
